
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../httpService/httpService";
import { useParams } from "react-router-dom";

export const fetchOngoingCampaign = createAsyncThunk(
  "camaign/fetchCampaign",
  async ({search, limit = 10,page=1 }, { rejectWithValue }) => {
    console.log("inside api call for fetching campaign") ;
    console.log(search);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(
        "/campaign-fetch/admin/appsells",
        {
          params: {
            campaign_name: search.campaign_name,
            start_date: search.createdAtFrom,
            end_date: search.createdAtTo,
            client_name: search.client_fullName,
            region: search.regions,
            city: search.cities,
            count: search.sites,
            page: page,
            limit: limit,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch clients");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching clients"
      );
    }
  }
);

const fetchCampaignSlice = createSlice({
  name: "campaign",
  initialState: {
    items: [],
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOngoingCampaign.pending, (state) => {
        state.status = "pending";
        state.loading = true;
      })
      .addCase(fetchOngoingCampaign.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchOngoingCampaign.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export default fetchCampaignSlice.reducer;
